import MerchantLegalEntityTable from './MerchantLegalEntityTable';
import MerchantLegalEntityMutate from './MerchantLegalEntityMutate';

// Importing Libs
import React from 'react';
import { Switch, Route, withRouter, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

// Importing styles
import './merchantLegalEntity.scss';
import Redirection from 'components/Redirection';
import CreateMle from './CreateMle';
import MleDraftTable from './MleDraftTable';
import EditViewMle from './EditViewMle';

const MerchantLegalEntity = ({ merchantLegalEntityData, auth }) => {
    const { formData, formEvents, uniqueIdentifier } = merchantLegalEntityData;
    
    const history = useHistory();

    // Extract 'permissions' directly from 'auth' and 'resourceDetails' objects.
    const {
        resourceDetails: { permissions },
    } = auth;

    return (
            <Switch>
                <Route exact path="/mle-onboarding">
                    <MerchantLegalEntityTable />
                </Route>

                <Route path="/mle-onboarding/create/:tabname">
                    <CreateMle
                        history={history}
                        permissions={permissions}
                        formData={formData}
                        formEvents={formEvents}
                        uniqueIdentifier={uniqueIdentifier}
                        isUpdate={false} // passing false as we are creating a new MLE
                    />
                </Route>

                <Route exact path="/mle-onboarding/draft">
                    <MleDraftTable />
                </Route>
                <Route path="/mle-onboarding/:event/:tabname/:merchantId">
                    <EditViewMle
                        history={history}
                        permissions={permissions}
                        formData={formData}
                        formEvents={formEvents}
                        uniqueIdentifier={uniqueIdentifier}
                    />
                </Route>
                <Route exact path="/mle-onboarding/:random/:random">
                   <Redirection 
                    message={'Requested Page cannot be Found!'}
                    path={'/mle-onboarding'}
                   />
                </Route>
                
                <Route exact path="/mle-onboarding/:random">
                   <Redirection 
                    message={'Requested Page cannot be Found!'}
                    path={'/mle-onboarding'}
                   />
                </Route>
            </Switch>
    );
};

MerchantLegalEntity.propTypes = {
    auth: PropTypes.object,
    merchantLegalEntityData: PropTypes.object,
};

const mapStateToProps = ({ auth, merchantLegalEntityData }) => ({
    auth,
    merchantLegalEntityData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MerchantLegalEntity)
);
